<template lang="html">

  <div class="candidaturas-view" v-if="!loading">

    <h2 v-if="esHome">{{$t('encabezado.recursos')}}</h2>
    <encabezado :data="'recursos'" v-else></encabezado>
    
    <div class="row cont-recurso" v-if="Object.keys(dominios.categoriasRecurso).length > 0" style="margin:40px 40px -60px 40px; ">
      <div class="contenedor-input type-multiple" style="margin: 0px 50px;">
        <h4 class="fake-label">{{ $t('oferta.categoria') }}</h4>
        <p>{{ $t('oferta.marca_categoria') }}</p>
        <div class="row-start">

          <div class="radio-container" v-for="(option, key) in dominios.categoriasRecurso">

            <template>
              <input type="checkbox" :value="Number(key)" :id="`doc-${key}`" v-model="selectedCategorias" :name="key">
              <label :for="`doc-${key}`" v-html="option"></label>
            </template>
          </div>

        </div>
      </div>
    </div>


    <div class="row cont-recurso" v-if="lRecursosFilter.length>0" >
      <template v-for="(recurso, key) in lRecursosFilter" style="margin:15px;">
        <recurso-el :data="recurso"></recurso-el>
      </template>
      <div class="row ver-mas-cont" v-if="esHome">
        <arrow-link class="arrow-link" :text="$t('ver_mas')" :to="$t('enlaces.recursos')" :external="false" :blank="false">
        </arrow-link>
      </div>
    </div>
    <h1 class="row cont-recurso" style="display:block;text-align:center;" v-else >
      No hay recursos para mostrar
    </h1>

  </div>

  <loading v-else-if="!esHome"></loading>

</template>

<script lang="js">

  import encabezado from '@/components/parts/encabezado';

  import {mapGetters, mapActions} from 'vuex';

  import loadingView from '@/components/parts/loading';

  import router from '@/router';

  import recursoEl from '@/components/views/noticias/recurso-el'
  
  import arrowLink from '@/components/parts/icons/arrow-link';
  
  export default  {
    name: 'recursos',
    props :['esHome'],
    components : {
      'encabezado' : encabezado,
      'loading' : loadingView,
      'recurso-el' : recursoEl,
      'arrow-link': arrowLink,
    },
    mounted(){
      this.getRecursos(this.isEmpresa).then(r => {
        this.lRecursos = r;
        this.loading = false;
      })
    },
    data(){
      return {
        loading: true,
        lRecursos: []
      }
    },
    methods: {
      ...mapActions([
        'getRecursos',
        'requestSetFiltroRecursos'
      ]),
    },
    computed : {
      ...mapGetters({
        colors : 'basicColors',
        style : 'getStyles',
        isEmpresa : 'isEmpresa',
        dominios: 'getDominios',
        filtrosRecursos: 'getfiltrosrecursos',
      }),
      selectedCategorias: {
        get() {
          return this.filtrosRecursos && this.filtrosRecursos.categorias ? [...this.filtrosRecursos.categorias] : [];
        },
        set(value) {
          this.requestSetFiltroRecursos({
            categorias: [...value]
          });
        }
      },
      lRecursosFilter : function(){
        if (this.lRecursos!=null && this.lRecursos.length>0){          
          var recursosFiltrados = this.lRecursos;
          //primero filtramos por categoria (si hay)
          if (Object.keys(this.dominios.categoriasRecurso).length > 0 && this.selectedCategorias.length > 0) {
            recursosFiltrados = recursosFiltrados.filter((r) => this.selectedCategorias.includes(r.idCategoriaRecurso));
          }

          //luego mostramos solo los 3 primeros si estamos en el home
          if (this.esHome) {
            recursosFiltrados = recursosFiltrados.slice(0, 3);
          }
          return recursosFiltrados;
        }else{
          return [];
        }
      }
    },
  }
</script>

<style scoped lang="scss">

  .candidaturas-view{
    width: 100%
  }

  h2{
    font-weight: 800;
    width: 100%;
    font-size: 36px;
    margin-top: 100px;
    color: #ff5700;
  }

  .row {
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    -ms-flex-wrap: wrap;
    flex-wrap: wrap;
    margin-right: -15px;
    margin-left: -15px;
  }

  .col-12{
    position: relative;
    width: 100%;
    min-height: 1px;
    padding-right: 15px;
    padding-left: 15px;
    -webkit-box-flex: 0;
    -ms-flex: 0 0 100%;
    flex: 0 0 100%;
    max-width: 100%;
  }
  
  .selector-tipo{
    margin-top: 50px;
  }

  .wrapper-filtro{
    margin-bottom: 0;
  }

  .status{
    border: none;
    outline: none;
    background-color: transparent;
    padding-left: 0;
    height: 30px;
    line-height: 30px;
    font-weight: 700;
    margin: 0 25px;
    cursor:pointer;
    opacity: .7;
  }

  .status[active="true"]{
    text-decoration: underline;
    opacity: 1;
  }

  @media screen and (max-width: 767px){

    .selector-tipo{
      margin-top: 25px;
    }

    .selector-tipo a{
      border-right: none;
      padding-right: 5px;
      margin-right: 5px;
      font-size: 12px;
    }


  }


  @media screen and (max-width: 380px){
    .selector-tipo a{
      padding-right: 3px;
      margin-right: 3px;
      font-size: 12px;
    }
  }


  @media screen and (max-width: 330px){
    .selector-tipo a{
      padding-right: 4px;
      margin-right: 4px;
      font-size: 10px;
    }
  }

  @media screen and (max-width: 500px){
    .status{
      margin: 0 10px;
    }
  }

  .btn-not-container{
    margin: 40px;
  }

  .-skull-primary{
    height: 43px;
    width: 156px;
  }

  .-solid-primary{
    height: 40px;
    width: 160px;
  }

  .cont-recurso{
    margin: 60px 200px;

    .ver-mas-cont{
      width: 100%;
      display: inline;
      text-align: center;

      .arrow-link{
        width: 100px;
        left: 48%;
        top: 25px;
        position: relative;
      }
    }
  }  

  @media screen and (max-width: 1200px){
    .cont-recurso{
      margin: 60px 40px;
    }
  }

</style>



// WEBPACK FOOTER //
// src/components/views/noticias/recursos.vue